/* unplugin-vue-components disabled */import script from "./CompanyType.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyType.vue?vue&type=script&setup=true&lang=js"

import "./CompanyType.vue?vue&type=style&index=0&id=3a1173a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a1173a2"]])

export default __exports__